import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=904b7452&functional=true"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/serbanhoratiutudor/Projects/genie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('904b7452')) {
      api.createRecord('904b7452', component.options)
    } else {
      api.rerender('904b7452', component.options)
    }
    module.hot.accept("./FormCheckbox.vue?vue&type=template&id=904b7452&functional=true", function () {
      api.rerender('904b7452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/FormCheckbox.vue"
export default component.exports